// import React from "react";
// import { Calendar, globalizeLocalizer } from "react-big-calendar";
// import globalize from "globalize";
// import i18n from "../../i18n";
// import { getAllCalendarData } from "../../models/calendar";
// import { getLoggedUser } from "../../state/user";

// const user = getLoggedUser();
// const localizer = globalizeLocalizer(globalize);

// const HomeBanner = ({ callbackForSupport }) => (
//   <div className="hero-banner">
//     <div className="hero-content">
//       <h1 className="hero-title">{i18n.t('auction_calendar')}</h1>
//       {/* <p className="hero-subtitle">Innovating for a Sustainable Future</p> */}
//     </div>
//   </div>
// );

// export class AuctionCalendar extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       eventsList: [],
//     };
//   }

//   componentDidMount() {
//     window.scrollTo(0, 0);
//     if (user && user.id) {
//       this.getAllData();
//     }
//   }

//   handleSelectEvent(e) {
//     window.location.href = "/auction-details/" + e.data.id;
//   }

//   async getAllData() {
//     const response = await getAllCalendarData();
//     if (response.success) {
//       this.setState({ eventsList: response.data });
//     }
//   }

//   createDate(dt) {
//     return dt ? new Date(dt.replace(/-/g, "/")) : null;
//   }

//   render() {
//     return (
//       <React.Fragment>
//         <HomeBanner callbackForSupport={this.props.callbackForSupport} />
//         <div className="main-content">
//           <div className="page-container m-1">
//             <div className="row">
//               <div className="col-1"></div>
//               <div className="col-10 p-3">
//                 <div className="blue-container">
//                   <div className="mx-3 mb-3 mobile_size">
//                     <i className="fa fa-calendar text-white"></i>
//                     <span class="custom-text5 ms-1 text-white">
//                       {i18n.t("auction_calendar")}
//                     </span>
//                   </div>
//                   <div className="container">
//                     <div className="row">
//                       <div className="bg-white user-brd rounded-4 px-0">
//                         <Calendar
//                           localizer={localizer}
//                           events={this.state.eventsList}
//                           startAccessor="start"
//                           endAccessor="end"
//                           style={{ height: 500 }}
//                           onSelectEvent={this.handleSelectEvent}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-1"></div>
//             </div>
//           </div>
//         </div>
//       </React.Fragment>
//     );
//   }
// }




import React from "react";
import { Calendar, globalizeLocalizer } from "react-big-calendar";
import globalize from "globalize";
import { ChevronLeft, ChevronRight, Grid, List, Filter } from "lucide-react";
import { getAllCalendarData } from "../../models/calendar";
import i18n from "../../i18n";
import { getLoggedUser } from "../../state/user";

const user = getLoggedUser();

const localizer = globalizeLocalizer(globalize);

const HomeBanner = ({ callbackForSupport }) => (
  <div className="hero-banner">
    <div className="hero-content">
      <h1 className="hero-title">{i18n.t('auction_calendar')}</h1>
      {/* <p className="hero-subtitle">Innovating for a Sustainable Future</p> */}
    </div>
  </div>
);

// Custom Calendar Components
const CustomToolbar = ({ onNavigate, onView, view, date, views }) => (
  <div className="toolbar-main" style={{
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 0',
    borderBottom: '1px solid #e5e7eb',
    marginBottom: '20px'
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
      <h2 style={{
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#1f2937',
        margin: 0
      }}>
        {date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}
      </h2>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          onClick={() => onNavigate('PREV')}
          style={{
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            background: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
          onMouseOut={(e) => e.target.style.background = 'white'}
        >
          <ChevronLeft size={16} />
        </button>
        <button
          onClick={() => onNavigate('TODAY')}
          style={{
            padding: '8px 16px',
            border: '1px solid white',
            borderRadius: '8px',
            background: 'linear-gradient(45deg, #189397, #4fc1c0)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.background = '#189397'}
          onMouseOut={(e) => e.target.style.background = 'linear-gradient(45deg, #189397, #4fc1c0)'}
        >
          {i18n.t('today')}
        </button>
        <button
          onClick={() => onNavigate('NEXT')}
          style={{
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '8px',
            background: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
          onMouseOut={(e) => e.target.style.background = 'white'}
        >
          <ChevronRight size={16} />
        </button>
      </div>
    </div>

    <div style={{
      display: 'flex',
      background: '#f8fafc',
      borderRadius: '12px',
      padding: '4px',
      gap: '2px' ,
      marginTop: '15px',
      width:'300px'
    }}>
      {views.map(viewName => (
        <button
          key={viewName}
          onClick={() => onView(viewName)}
          style={{
            padding: '8px 16px',
            border: 'none',
            borderRadius: '8px',
           
            background: view === viewName ? 'white' : 'transparent',
            color: view === viewName ? '#1f2937' : '#6b7280',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: '500',
            textTransform: 'capitalize',
            transition: 'all 0.2s ease',
            boxShadow: view === viewName ? '0 1px 3px rgba(0,0,0,0.1)' : 'none'
          }}
        >
          {viewName}
        </button>
      ))}
    </div>
  </div>
);

const EventComponent = ({ event }) => (
  <div style={{
    background: getEventColor(event.data?.type),
    color: 'white',
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '0.75rem',
    fontWeight: '500',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    border: 'none',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
  }}>
    {event.title}
  </div>
);

const getEventColor = (type) => {
  const colors = {
    art: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    automotive: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
    jewelry: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
    realestate: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
    default: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)'
  };
  return colors[type] || colors.default;
};

export class AuctionCalendar extends React.Component {



  constructor(props) {
    super(props);
    this.state = {
      eventsList: [],
      currentView: 'month',
      currentDate: new Date(),
      loading: true
    };

    this.handleSelectEvent = this.handleSelectEvent.bind(this);
    this.handleViewChange = this.handleViewChange.bind(this);
    this.handleNavigate = this.handleNavigate.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (user && user.id) {
      this.getAllData();
    }
  }

  handleSelectEvent(event) {
    // Add subtle animation feedback
    const target = document.activeElement;
    if (target) {
      target.style.transform = 'scale(0.95)';
      setTimeout(() => {
        if (target.style) target.style.transform = 'scale(1)';
      }, 100);
    }

    window.location.href = "/auction-details/" + event.data.id;
  }

  handleViewChange(view) {
    this.setState({ currentView: view });
  }

  handleNavigate(newDate) {
    this.setState({ currentDate: newDate });
  }

  async getAllData() {
    this.setState({ loading: true });
    try {
      const response = await getAllCalendarData();
      if (response.success) {
        this.setState({
          eventsList: response.data.map(event => ({
            ...event,
            start: this.createDate(event.start),
            end: this.createDate(event.end)
          }))
        });
      }
    } catch (error) {
      console.error('Failed to load calendar data:', error);
    } finally {
      this.setState({ loading: false });
    }
  }

  createDate(dt) {
    if (!dt) return null;
    if (dt instanceof Date) return dt;
    return new Date(dt.replace ? dt.replace(/-/g, "/") : dt);
  }

  render() {
    const calendarStyle = {
      height: '600px',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
    };

    const formats = {
      timeGutterFormat: 'HH:mm',
      eventTimeRangeFormat: ({ start, end }) => {
        return `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      },
      agendaTimeFormat: 'HH:mm',
      agendaTimeRangeFormat: ({ start, end }) => {
        return `${start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
      }
    };

    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      }}>
        <HomeBanner callbackForSupport={this.props.callbackForSupport} />

        <div className="main-content">
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '40px 20px'
          }}>
            <div style={{
              background: 'white',
              borderRadius: '20px',
              padding: '30px',
              boxShadow: '0 20px 50px rgba(0,0,0,0.1)',
              border: '1px solid rgba(255,255,255,0.2)'
            }}>



              <Calendar
                localizer={localizer}
                events={this.state.eventsList}
                startAccessor="start"
                endAccessor="end"
                style={calendarStyle}
                onSelectEvent={this.handleSelectEvent}
                onView={this.handleViewChange}
                onNavigate={this.handleNavigate}
                view={this.state.currentView}
                date={this.state.currentDate}
                formats={formats}
                components={{
                  toolbar: CustomToolbar,
                  event: EventComponent
                }}
                views={['month', 'week', 'day', 'agenda']}
                step={30}
                showMultiDayTimes
                popup
                popupOffset={{ x: 10, y: 10 }}
              />

              {this.state.eventsList.length === 0 && (
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#6b7280'
                }}>
                  <div style={{
                    fontSize: '48px',
                    opacity: 0.3,
                    marginBottom: '16px'
                  }}>📅</div>
                  <p style={{ fontSize: '1.1rem', margin: 0 }}>
                    {i18n.t('no_events')}
                  </p>
                </div>
              )}


            </div>
          </div>
        </div>
      </div>
    );
  }
}



